// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export const getEarningGraphData = (id) => {
  const url = `${getLocationOrigin()}/${appConfig.earningGraph.data.API}/?venue_id=${id}`;
  const options = {...defaultOptions};

  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/earningGraph.js